import Marquee from "react-fast-marquee";

const ITEMS = [
  "High-Voltage Installations",
  "Power Distribution",
  "Emergency Diagnostics",
  "Systems Automation",
  "Offshore Wind",
  "Marine Vessels",
  "SLA Consulting",
];

export default function EditorialMarquee() {
  return (
    <section
      className="relative border-y border-white/10 bg-[#0A111D] py-6 overflow-hidden"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif-display italic text-3xl sm:text-5xl text-[#F8FAFC]/90 px-8">
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-[#FF5A00]" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
